import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import { Box, Button, Stack } from '@chakra-ui/react'
import React from 'react'

interface FooterButtonsProps {
  onBack: () => void;
  backText: string;
  backDisabled?: boolean;
  onNext: () => void;
  nextText: string;
  nextDisabled?: boolean;
  onSkip?: () => void;
  skipText?: string;
  skipDisabled?: boolean;
  loading?: boolean;
  showButtonBack?:boolean
}

const FooterButtons: React.FC<FooterButtonsProps> = ({
  onBack,
  backText,
  backDisabled = false,
  onNext,
  nextText,
  nextDisabled = false,
  onSkip,
  skipText,
  skipDisabled = false,
  loading = false
}) => (
  <Stack
    boxShadow='0px -3px 8px 4px rgba(0, 0, 0, 0.10)'
    px={12}
    py={6}
    justify='space-between'
    direction='row'
    align='center'
    position='fixed'
    bottom={0}
    ml='76px'
    left={0}
    right={0}
    bg='white'
  >
    <Box>
      <Button
        leftIcon={<ChevronLeftIcon boxSize={6} />}
        variant='primary-text'
        onClick={onBack}
        disabled={backDisabled}
      >
        {backText}
      </Button>
    </Box>
    <Box>
      {skipText && (
        <Button
          variant='primary-outline'
          disabled={skipDisabled}
          color='primary.500'
          onClick={onSkip}
          mr={10}
        >
          {skipText}
        </Button>
      )}
      <Button
        rightIcon={<ChevronRightIcon boxSize={6} />}
        isLoading={loading}
        disabled={nextDisabled}
        onClick={onNext}
      >
        {nextText}
      </Button>
    </Box>
  </Stack >
)


export default FooterButtons